import PropTypes from 'prop-types';
import React from 'react';

import { withRouter } from 'react-router-dom';

import qs from "qs";

import { datastoreComponentConnect } from './DatastoreComponentMixin.jsx';
import { illegalNameChars } from '../util/topic.js';

const TTL_RESET_SUCCESS_ERROR = 600;

/**
 * TableCell
*/
class TableCell extends React.Component {
    static format = {
        formatAndHide100: function (input) {
            if (input > 0.998) {
                return ["100.0", true];
            }
            input = parseFloat(input * 100).toFixed(1);
            return [input, false];
        },
        formatAndHide100AndNegative: function (input) {
            if (input > 0.998 || input <= 0.01) {
                return ["100.0", true];
            }
            input = parseFloat(input * 100).toFixed(1);
            return [input, false];
        },
        negativeIsInactive: function (input, props) {
            if (input <= 0) {
                return ["0", true];
            }
            if (props.dataRound !== undefined) {
                return [parseFloat(input).toFixed(props.dataRound !== undefined ? props.dataRound : 2), false];
            }
            return [input, false];
        },
        multiplyBy: function (input, props) {
            if (input === 0) {
                return [0, true];
            }
            if (!props.factor) {
                return [input, false];
            }
            if (props.dataRound !== undefined) {
                return [parseFloat((+input) * props.factor).toFixed(props.dataRound !== undefined ? props.dataRound : 2), false];
            }
            return [((+input) * props.factor), false];
        }
    }
    static contextTypes = {
        basePath: PropTypes.string,
        uuid: PropTypes.string,
        constructTitle: PropTypes.func,
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired,
        alerts: PropTypes.array,
        warnings: PropTypes.array
    }

    state = {
        overrideValue: null,
        illegalCharsFound: false,
        isFocused: false,
        loading: false,
        showSuccess: false,
        resetStateTimeout: 0
    };

    openChart = () => {
        this.props.history.push({
            pathname:"/devices/" + this.context.uuid + "/chart-" + encodeURIComponent(this.context.basePath + this.props.dataPath),
            search: "?" + qs.stringify({
                name: this.props.chartTitle ? this.props.chartTitle : this.context.constructTitle(this.props)
            })
        });
    }
    
    handleChanged = (ev) => {
        const input = this.refs.input;
        const newValue = input.value;
        if (ev.keyCode === 13) {
            // p.put(this.props.basePath + this.props.dataPath, newValue);
            this.onInputSubmit(ev);
            return true;
        }
        // Get current topic value
        let value = this.props.data;
        if (value) {
            if (this.props.data.new !== undefined && this.props.data.new !== null) {
                value = this.props.data.new;
            } else if (this.props.subAttr !== undefined && value[this.props.subAttr] !== undefined) {
                value = this.props.data[this.props.subAttr];
            }
        }

        if (value === newValue) {
            this.setState({
                "overrideValue": null,
                "illegalCharsFound": null
            });
        } else {
            const illegalCharsFound = newValue.match(illegalNameChars);
            this.setState({
                "overrideValue": newValue,
                "illegalCharsFound": illegalCharsFound
            });
        }
        return true;
    }

    handleConfigCallback = () => {
        if (this.props.configCallback) {
            this.props.configCallback(this.props);
        }
    }
    
    static getDerivedStateFromProps(nextProps, state) {
        let value = nextProps.data;
        const self = this;
        if (value) {
            if (nextProps.data.new !== undefined && nextProps.data.new !== null) {
                value = nextProps.data.new;
                if (!state.loading) {
                    return {
                        loading: true
                    };
                }
            } else {
                if (nextProps.subAttr !== undefined && value[nextProps.subAttr] !== undefined) {
                    value = value[nextProps.subAttr];
                }
                if (state.loading) {
                    let wasSuccess = (value === state.overrideValue);
                    return {
                        loading:false,
                        showSuccess: wasSuccess,
                        showError: (nextProps.data.error !== undefined),
                        overrideValue: null,
                        resetStateTimeout: (wasSuccess ? setTimeout(function () {
                            self.setState({showSuccess: false, showError: false});
                        }, TTL_RESET_SUCCESS_ERROR) : 0)
                    };
                }
            }
        }
        return null;
    }

    onFocus = () => {
        if (this.state.resetStateTimeout !== 0) {
            clearTimeout(this.state.resetStateTimeout);
        }

        this.setState({isFocused: true, showSuccess: false, resetStateTimeout: 0});
    }

    onBlur = () => {
        this.setState({isFocused: false});
    }

    onInputCancel(ev) {
        this.setState({'overrideValue': null});
        ev.target.blur();
        ev.preventDefault();
    }

    onInputSubmit = (ev) => {
        ev.target.blur();
        ev.preventDefault();

        this.setState((state) => {
            // Don't send with illegal chars in field
            if (state.illegalCharsFound) {
                return;
            }
            if (state.overrideValue !== undefined && state.overrideValue !== null) {
                let valueToSend;
                if (this.props.subAttr) {
                    valueToSend = {};
                    valueToSend[this.props.subAttr] = state.overrideValue;
                } else {
                    valueToSend = state.overrideValue;
                }

                this.context.p.put(this.props.basePath + this.props.dataPath, valueToSend);
                return {loading: true, showSuccess: false};
            } else {
                return {'overrideValue': null, showSuccess: true};
            }

        });
    }

    render() {
        const self = this;
        var value = this.props.data;
        let valueIsOld = false;
        let valueExists = true;
        const fullPath = this.context.basePath + this.props.dataPath;

        if (value) {                
            if (this.props.data.new !== undefined && this.props.data.new !== null && this.props.data.new[this.props.subAttr]) {
                value = this.props.data.new[this.props.subAttr];
            } else if (this.props.subAttr !== undefined) {
                value = value[this.props.subAttr];
                valueExists = (value !== undefined);
            }
            if (this.props.data.ts !== undefined && this.props.isData) {
                valueIsOld = (this.props.data.ts < Date.now() - 120*1000);
            }

            if (typeof value === 'object') {
                console.trace("value is object", this.value, this.props.basePath + this.props.dataPath);
            }
        }
        if (this.state.overrideValue !== undefined && this.state.overrideValue !== null) {
            value = this.state.overrideValue;
        }
        var numericValue = +value;
        var valueIsEmpty = false;
        if (this.props.format && this.format[this.props.format]) {
            [value, valueIsEmpty] = this.format[this.props.format](value, this.props);
        } else {
            if (this.props.dataRound !== undefined && value) {
                value = parseFloat(value).toFixed(this.props.dataRound !== undefined ? this.props.dataRound : 2);
            }
        }
        if (this.props.isConfig && valueExists && !this.props.readOnly) {
            let tdClass = this.props.tdClass ? this.props.tdClass : "", saveInputClass = "saveinput";
            let inputAttributes = {
                onFocus: self.onFocus,
                onBlur: self.onBlur,
                onChange: this.handleChanged,
                onKeyDown: this.handleChanged
            };
            if (this.state.showSuccess) {
                tdClass += " success";
            } else if (this.state.loading) {
                tdClass += " processing";
                inputAttributes.disabled = "disabled";
            } else {
                if (this.state.isFocused || 
                    (this.state.overrideValue !== undefined && this.state.overrideValue !== null)) {
                    if (this.state.overrideValue === undefined || this.state.overrideValue === null) {
                        saveInputClass += " unchanged";
                    }
                    tdClass += " focus";
                }
            }
            if (value === undefined || value === null) {
                value = "";
            }

            let inputGroupClasses = "input-group";
            let inputButtonSave = this.context.t("details_configuration.button_save_change");
            let inputButtonClasses = "btn input-group-btn btn-sm saveinput";

            if (this.state.illegalCharsFound) {
                inputGroupClasses += " has-error";
                inputButtonSave = this.context.t("details_configuration.button_error_illegal_chars", {chars: this.state.illegalCharsFound.join(", ")});
                inputButtonClasses += " btn-error";
            }

            return (
                <td className={tdClass}>
                    <div className={inputGroupClasses}>
                        <a className="cancelinput btn input-group-btn btn-sm" onClick={self.onInputCancel} >X</a>
                        <input {...this.props.inputProps} {...inputAttributes}  ref="input" value={ value } className="form-input input-sm"/>
                        <a className={inputButtonClasses} disabled={!!this.state.inputGroupClasses} onClick={self.onInputSubmit}>{inputButtonSave}</a>
                    </div>
                </td>
            );
        }
        
        let unitSpan = null;
        if (value !== undefined && value !== null) {
            if (this.props.unit) {
                unitSpan = (
                    <span className="unit">&nbsp;{this.props.unit}</span>
                );
            } else if (value.u) {
                let unitText;
                if (this.props.unitTranslatePrefix) {
                    unitText = this.context.t(this.props.unitTranslatePrefix + "." + this.value.u);
                } else {
                    unitText = value.u;
                }
                unitSpan = (
                    <span className="unit">&nbsp;{unitText}</span>
                );
            }
        }

        let tdClass = this.props.tdClass ? this.props.tdClass : "";
        let canShowChart = false;
        if (this.props.tdClass) {
            tdClass = this.props.tdClass + (this.props.isFlashing ? " push" : "");
        } else {
            if (this.props.isFlashing) {
                tdClass = "push";
            } else if (!value || valueIsEmpty) {
                tdClass = "empty";
            }
        }

        if (this.props.subAttr === "v" && !this.props.alignRight) {
            tdClass += " ta-right clickable";
            canShowChart = true;
        }

        if (valueIsOld) {
            tdClass += " oldValue";
        }

        let configButton = null;
        if (this.props.popupName && !this.props.isConfig) {

            // if (this.thresholdSerial !== this.context.thresholdSerial) {
            //     this.threshold = getThreshold(fullPath, this.context.p);
            // }
            // let thresholdClasses;
            // if (this.threshold?.thr) {
                
            //     const hasSpecificRule = this.threshold?.path === fullPath;

            //     if (hasSpecificRule) {
            //         thresholdClasses = "fa fa-sliders hasown";
            //     } else {
            //         thresholdClasses = "fa fa-sliders hasrule";
            //     }
            //     configButton = (
            //         <span className={thresholdClasses}></span>
            //     );
            // }

            const baseItem = this.context.p.getPath(this.context.basePath);

            const alertIdx = baseItem?.a?.indexOf(fullPath);
            const isAlerted = alertIdx !== undefined && alertIdx !== -1;
            let isWarned = false;
            if (!isAlerted) {
                const warnIdx = baseItem?.w?.indexOf(fullPath);
                isWarned = warnIdx !== undefined && warnIdx !== -1;
            }

            if (isAlerted) {
                tdClass += " critical";
            } else if (isWarned) {
                tdClass += " warning";
            }
        }

        if (this.props.translatePrefix) {
            value = this.context.t(this.props.translatePrefix + "." + value?.toLowerCase());
        }
        var label = this.props.title;
        if (label && this.props.labelFormatter) {
            label = this.props.labelFormatter(this.props.title);
        }
        var tdProperties = {};
        if (this.props.colspan) {
            tdProperties.colspan = this.props.colspan;
        }
        if (this.props.rowspan) {
            tdProperties.rowspan = this.props.rowspan;
        }

        if (canShowChart) {
            if (this.props.chartTitle) {
                return (
                  <td title={label} className={tdClass}><span onClick={this.openChart}>{ value }{ unitSpan }</span>{ this.props.children }{ configButton }</td>
                );
            } else {
               return ( 
                <td title={label} className={tdClass}><span> { value }{ unitSpan }</span>{ this.props.children }{ configButton }</td>
               );
            }
        } else {
            return (
                <td title={label} className={tdClass}>{ value }{ unitSpan }{ this.props.children }{ configButton }</td>
            );
        }
    }
}

TableCell.defaultProps = {
    "subAttr": "v"
};

export default withRouter(datastoreComponentConnect(TableCell, true));